import type { StateMessageVariant } from "@/ds";

export const DETAIL_SECTION_RETRY_LABEL = "Tentar novamente";
export const DETAIL_SECTION_REAUTH_LABEL = "Entrar novamente";

/** Ícone do PrimeIcons de cada situação sem desenho no Figma; as demais usam o padrão da variante. */
export const DETAIL_SECTION_STATE_ICONS = {
  sessionExpired: "pi pi-lock",
  notFound: "pi pi-search-minus",
} as const;

/** Variante do `StateMessage` de cada situação da consulta; a seção vazia usa o `EmptyState`. */
export const DETAIL_SECTION_STATE_VARIANTS: Record<
  "loading" | "sessionExpired" | "forbidden" | "notFound" | "error",
  StateMessageVariant
> = {
  loading: "loading",
  sessionExpired: "forbidden",
  forbidden: "forbidden",
  notFound: "info",
  error: "error",
};
